import { CrmAppEnvironment } from 'common-module/core';
import { CrmEndpointModuleConfig } from 'common-module/endpoint';
import packageJson from '../../../package.json';

interface AppEnvironment extends CrmAppEnvironment {
  production: boolean;
  baseURL: string;
  basicAuthToken: string;
  env: string;
  projectName: string;
  mediaURL: string;
  version: string;
}

export const environment: AppEnvironment = {
  production: false,
  baseURL: 'https://api.ferrero.k8s.touch4dev.net',
  basicAuthToken: 'ZmVycmVybzo0eEpNd2tRNWcyYms1dlFS',
  env: 'development',
  projectName: 'Teamfolio',
  mediaURL: 'https://api.ferrero.k8s.touch4dev.net',
  version: packageJson.version,
};

export const endpointModuleConfiguration: CrmEndpointModuleConfig = {
  endpoints: [
    {
      name: 'crm',
      baseUrl: environment.baseURL,
      withCredentials: true,
      httpHeaders: {
        Authorization: `Basic ${environment.basicAuthToken}`,
      },
    },
  ],
};
